var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0524 26.0524L33.6774 33.6774M33.6774 26.0524L26.0524 33.6774M42.9367 43.0053L50.765 50.8337M48.292 29.2295C48.292 34.2852 46.2836 39.1338 42.7087 42.7087C39.1338 46.2836 34.2852 48.292 29.2295 48.292C24.1738 48.292 19.3252 46.2836 15.7503 42.7087C12.1754 39.1338 10.167 34.2852 10.167 29.2295C10.167 24.1738 12.1754 19.3252 15.7503 15.7503C19.3252 12.1754 24.1738 10.167 29.2295 10.167C34.2852 10.167 39.1338 12.1754 42.7087 15.7503C46.2836 19.3252 48.292 24.1738 48.292 29.2295Z",
    stroke: "#5070DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.26b88f360e57b0639d85ef22433f6814.svg";
export { ForwardRef as ReactComponent };